import {
  bulkEditActionForUser,
  downloadErrorSheet,
  downloadErrorSheetForKAM,
  downloadExcelForKAM,
  fetchLineItemsForKam,
  fetchLineItemsForUser,
  sendQoutationToUser,
  uploadExcelForKAM
} from 'home/view/manage-feasibility/services/multiSite-service';
import { _get, _post } from 'home/view/manage-feasibility/services/service-util';
import { isUserTypeIsKAM } from './configure-plan-pricing-constant';

export const downloadExcel = (config) => {
  return isUserTypeIsKAM() ? downloadExcelForKAM(config) : _get('lead/bulkDownload/locations', config);
};

export const uploadExcel = (request, config) => {
  return isUserTypeIsKAM() ? uploadExcelForKAM(request, config) : _post('lead/bulkUpload/locations', request, config);
};

export const fetchLineItems = (params) => {
  return isUserTypeIsKAM() ? fetchLineItemsForKam(params) : fetchLineItemsForUser(params);
};

export const downloadErrorSheets = (errorSheetUrl, authorizationToken) => {
  return isUserTypeIsKAM() ? downloadErrorSheetForKAM(errorSheetUrl, authorizationToken) : downloadErrorSheet(errorSheetUrl, authorizationToken);
};

export const sendQuotation = (request) => {
  return sendQoutationToUser(request);
};

export const doBulkEditAction = (params) => {
  return bulkEditActionForUser(params);
};
